import React from 'react';
import PropTypes from 'prop-types';
import styles from './ContractHeader.module.css';

const LabelValue = ({ label, value }) => (
	<div className={styles.container}>
		<div className={styles.label}>{label}</div>
		<div className={styles.content}>{value}</div>
	</div>
);

const ContractTeamHeader = ({ qualYear, apptType, teamTitle, teamCode }) => (
	<div className={styles.header}>
		<div className={styles.row}>
			<LabelValue label="Qualification Year" value={qualYear} />
			<LabelValue label="Marking Team" value={teamTitle} />
		</div>
		<div className={styles.row}>
			<LabelValue label="Appointment Type" value={apptType} />
			<LabelValue label="Marking Team Code" value={teamCode} />
		</div>
	</div>
);

ContractTeamHeader.propTypes = {
	qualYear: PropTypes.number.isRequired,
	apptType: PropTypes.string.isRequired,
	teamTitle: PropTypes.string.isRequired,
	teamCode: PropTypes.string.isRequired
};

export default ContractTeamHeader;
